import React from 'react';

export default
    <g id="icon/whiteboard/fretboard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path d="M25,0 L25,64 L1.45519152e-11,64 L1.45519152e-11,0 L25,0 Z M21,4 L4,4 L4,60 L21,60 L21,4 Z" id="Rectangle" fill="currentColor" fillRule="nonzero"></path>
        <path d="M44,0 L44,64 L20,64 L20,0 L44,0 Z M40,4 L24,4 L24,60 L40,60 L40,4 Z" id="Rectangle" fill="currentColor" fillRule="nonzero"></path>
        <path d="M64,0 L64,64 L39,64 L39,0 L64,0 Z M60,4 L43,4 L43,60 L60,60 L60,4 Z" id="Rectangle" fill="currentColor" fillRule="nonzero"></path>
        <circle id="Oval" fill="currentColor" cx="32" cy="32" r="3"></circle>
    </g>